import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Bell } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

/**
 * Phase 2 (Jul 2026) — quiet one-line replacement for the coming-soon
 * department CARDS on the homepage. Full cards said "this store is
 * unfinished" in prime space; this strip keeps the departments
 * discoverable + preserves the notify-me lead capture (each name links
 * to its /d/<slug> page where the notify flow lives) without making a
 * promise-sized moment out of what we DON'T sell yet.
 *
 * Renders nothing when no coming-soon departments exist — so the strip
 * self-retires the day Jewellery/Bags go live.
 */
export default function ComingSoonStrip() {
    const [depts, setDepts] = useState([]);

    useEffect(() => {
        let alive = true;
        axios.get(`${API}/departments`)
            .then(r => { if (alive) setDepts((r.data || []).filter(d => d.status === "coming_soon")); })
            .catch(() => { /* strip simply doesn't render */ });
        return () => { alive = false; };
    }, []);

    if (depts.length === 0) return null;

    return (
        <section className="mb-10 lg:mb-16 animate-fade-up" data-testid="coming-soon-strip">
            <div className="flex flex-wrap items-center justify-center gap-x-2 gap-y-1 rounded-2xl border border-stone-200/80 bg-ivory-soft/60 px-5 py-3.5 text-[12px] text-ink-soft">
                <span>
                    {depts.map(d => d.name).join(" & ")} {depts.length === 1 ? "is" : "are"} coming to the boutique
                </span>
                <span aria-hidden className="hidden sm:inline text-stone-300">·</span>
                {depts.map(d => (
                    <Link
                        key={d.slug}
                        to={`/d/${d.slug}`}
                        data-testid={`coming-soon-notify-${d.slug}`}
                        className="inline-flex items-center gap-1 font-semibold text-rosegold hover:text-wine transition-colors"
                    >
                        <Bell size={11} /> Get notified · {d.name}
                    </Link>
                ))}
            </div>
        </section>
    );
}
